var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "related-videos",
      style: { backgroundColor: "transparent" },
      attrs: { id: "related-videos", "data-ui-section": "related-videos" }
    },
    [
      _c("WebcallDataProvider", {
        attrs: { "fetch-fn": _vm.getRelatedVideoTag, "initial-data": [] },
        on: { update: _vm.setDefaultActiveEndpoint },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var relatedVideoEndpoints = ref.data
              return [
                _c(
                  "div",
                  { staticClass: "container pt-3 pt-md-0  m-0 w-100" },
                  [
                    [
                      _c(
                        "keep-alive",
                        _vm._l(
                          _vm.filterForActiveRelatedEndpoint({
                            relatedVideoEndpoints: relatedVideoEndpoints
                          }),
                          function(relatedVideoEndpoint) {
                            return _c("VerticalRecommendedVideos", {
                              key: relatedVideoEndpoint.id,
                              attrs: {
                                "related-video-endpoint": relatedVideoEndpoint
                              },
                              on: { update: _vm.handleRelatedVideosUpdate }
                            })
                          }
                        ),
                        1
                      )
                    ]
                  ],
                  2
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }